<template>
  <v-card flat class="text-xs-center">
    <v-card-title class="pa-0 justify-center">
      <h4 class="pb-2">
        {{ campaign.RetireKeepTitle }}
      </h4>
    </v-card-title>
    <v-card-text class="pa-0">
      <p>
        {{ campaign.RetireKeepDesc }}
      </p>
    </v-card-text>
    <v-card-actions class="justify-center">
      <div class="button-bar">
        <delete-confirm-modal
          :title="assetName"
          button-id="MarkForDeletion"
          button-class="sb_btn_solid error"
          :button-text="campaign.RetireButton"
          :custom-text="`Retire asset &quot;${assetName}&quot;?`"
          confirm-button-text="Yes"
          cancel-button-text="No"
          hide-header-title
          @confirm="markForDeletion"
        />
        <v-btn
          id="KeepButton"
          class="ml-3 sb_btn_solid"
          color="success"
          @click="keepClicked"
        >
          {{ campaign.KeepButton }}
          <v-icon class="ml-1">
            {{ SbIcons.arrow.right }}
          </v-icon>
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import DeleteConfirmModal from '../../DeleteConfirmModal.vue';
import reviewStepBase from './reviewStepBase.mixin.js';

export default {
  name: 'AssetReviewStepDelete',
  components: { DeleteConfirmModal },
  mixins: [reviewStepBase],
  computed: {
    assetName() {
      return this.asset['Name'];
    },
    campaign() {
      return this.$store.state.campaignDetails.overview;
    },
  },
  methods: {
    markForDeletion() {
      const updateId = this.asset.CampaignAssetId;
      this.$emit('delete-confirmed', updateId);
    },
    keepClicked() {
      this.$emit('keepOnClick');
    },
  },
};
</script>
